import { AxiosError } from 'axios';

export enum ViewModes {
  DEFAULT = '0',
  KIOSK = '2',
  FTNFT_AM = '3',
  KIOSK_AM = '4',
  KIOSK_VENICE = '5'
}

export type TButtonSize = 'normal' | 'wider' | 'wide' | 'fullWidth';

export type TSpinType = 'static' | 'fixed' | 'absolute' | 'fit';

export type TPreviewType = 'collection' | 'creator';

export type TImageType =
  | 'payment'
  | 'empty'
  | 'success'
  | 'payment-fail'
  | 'payment-success'
  | 'user';

type PFDesignMakerProps = {
  featureConfig: {
    new_layout: boolean;
  };
  elemId: string;
  applyImageFromUrl: string;
  nonce: string;
  technique: 'T-SHIRT' | 'EMBROIDERY';
  initProduct: {
    productId: number;
  };
  onTemplateSaved: (templateId: number) => void;
  onDesignStatusUpdate: (e: {
    designChanged: boolean;
    designValid: boolean;
    selectedVariantIds: number[];
  }) => void;
};

export type IFile = {
  file: {
    uid: string;
    lastModified: number;
    lastModifiedDate: string;
    name: string;
    size: number;
    type: string;
    percent: 100;
    originFileObj: {
      preview?: string;
      uid: string;
      lastModified: number;
      lastModifiedDate: string;
      name: string;
      size: number;
      type: string;
      webkitRelativePath: string;
    };
    status: string;
    response: string;
  };
  fileList: [
    {
      uid: string;
      lastModified: number;
      lastModifiedDate: string;
      name: string;
      size: number;
      type: string;
      percent: number;
      originFileObj: {
        preview?: string;
        uid: string;
        lastModified: number;
        lastModifiedDate: string;
        name: string;
        size: number;
        type: string;
        webkitRelativePath: string;
      };
      status: string;
      response: string;
    }
  ];
};

export type TLanguageInfo = {
  id: number;
  designPresetId: null;
  language: string;
  country: string;
  name: string;
  nativeName: string;
  code: string;
  slug: string;
  domainId: null;
  default: boolean;
  order: number;
  hidden: boolean;
  createdAt: string;
  updatedAt: string;
  disabledAt: null;
  flag: null;
  rtl: boolean;
  enforceUnicode: boolean;
  unicodeCharacters: string;
  direction: string;
  current: boolean;
  canonical: string;
  hreflang: string;
  path: string;
  isCustomDomain: boolean;
  isDefaultDomain: boolean;
};

declare global {
  interface Window {
    partnerConfigs: {
      apiUrl?: string;
      viewMode?: ViewModes;
      nftsPagePath: string;
      loginPagePath?: string;
      registerPagePath?: string;
      translationsVersion?: string;
      userFilesUrl?: string;
      metamaskIntegration?: boolean;
      baseUrl?: string;
      cartEnabled?: boolean;
    };
    page?: {
      alias: string;
      homepage: 0 | 1;
    };
    initWidgets: () => void;
    analytics?: {
      track?: Function;
      identify?: Function;
    };
    zE?: Function;
    mockedData?: boolean;
    // internal functionality attached for external usage [START]
    openSigninPopup: () => void;
    openAccountMyNfts: () => void;
    openAccountCreateNft: (skipStorage?: boolean) => void;
    loggedInCheck: () => void;
    // internal functionality attached for external usage [END]
    PFDesignMaker?: {
      new (options: PFDesignMakerProps): {
        sendMessage: Function;
      };
    };
    $hoory?: {
      baseUrl: string;
      hasLoaded: boolean;
      isOpen: boolean;
      websiteToken: string;
      hideMessageBubble: boolean;
      position: string;
      useBrowserLanguage: boolean;
      type: string;
      launcherTitle: string;
      showPopoutButton: boolean;
      widgetStyle: string;
      darkMode: string;
      resetTriggered: boolean;
      deleteConversationCustomAttribute: () => void;
      deleteCustomAttribute: () => void;
      popoutChatWindow: () => void;
      removeLabel: () => void;
      reset: () => void;
      setConversationCustomAttributes: () => void;
      setCustomAttributes: () => void;
      setLabel: () => void;
      setLocale: () => void;
      setUser: () => void;
      toggle: () => void;
      toggleBubbleVisibility: (arg: 'hide' | 'show') => void;
    };
    // ucraft instance
    currentLanguageObject?: {
      id: number;
      ordering: number;
      title: string;
      language: string;
      prefix: string;
      locale: string;
      region: string;
      flag: string;
      default: 0 | 1;
      published: number;
      createdAt: string;
      updatedAt: string;
      deletedAt: null;
      enforceUnicodeAliases: number;
      unicodeCharactersReplacement: string;
      flagChanged: boolean;
      homeUrl: null;
      shortLocale: string;
      url: string;
    };
    // ucraft next instance (new)
    __NEXT_DATA__?: {
      props: {
        pageProps: {
          languageInfo: TLanguageInfo;
          pageData: {
            path: string;
          };
        };
      };
    };
  }

  interface External {
    showTapPage: (arg: boolean) => void;
    printBase64Ticket: (arg: string) => void;
    getTerminalId: () => Promise<string>;
  }

  interface EventListener {
    (evt: Event | CustomEvent): void;
  }

  interface EventListenerObject {
    handleEvent(object: Event | CustomEvent): void;
  }
}

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export enum RestBoolean {
  False,
  True
}

/**
 *  Creates a type from a composite type making all properties besides
 * mentioned in 2nd parameter optional
 */
export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>;
/**
 * Creates a type from a composite type making all properties mentioned in 2nd
 * parameter optional
 */
export type PartialSelective<T, K extends keyof T> = Partial<T> & Omit<T, K>;

export type RestAxiosError = AxiosError<{
  message?: string;
  error_code?: string;
}>;
// eslint-disable-next-line no-restricted-syntax
export default {};
